import moment from "moment";
import _isNil from "lodash/isNil";
import jwtDecode from "jwt-decode";

import { logoutUser } from "./auth";
import { isSukiUserAdmin } from "./user";
import { LO_STO, ORGS } from "../util/constants";
// import clients
const { AutherClient } = require("../protos/auther_grpc_web_pb");
const { IngesterServiceClient } = require("../protos/ingester_grpc_web_pb");

let environment = "https://s3-gw.suki-dev.com";

const isEnvironmentDev = () => window.location.origin.match(/dev/i);
const isEnvironmentTest = () => window.location.origin.match(/test/i);
const isEnvironmentStage = () => window.location.origin.match(/stage/i);
const isEnvironmentProd = () => window.location.origin.match(/suki\.ai/i);
const getCheckId = () => {
  let checkId = "uptime-grpc-ssp-asr-vocera-7t6Lc86j_fk";
  if (isEnvironmentDev()) {
    checkId = "uptime-grpc-ssp-asr-vocera-7t6Lc86j_fk";
  } else if (isEnvironmentTest()) {
    checkId = "uptime-grpc-ssp-asr-vocera-CA_PD1EWHqM";
  } else if (isEnvironmentStage()) {
    checkId = "uptime-grpc-ssp-asr-vocera-nk21fEw-STM";
  } else if (isEnvironmentProd()) {
    checkId = "uptime-grpc-ssp-asr-vocera-I4TC8Sxdr0o";
  }

  return checkId;
};

if (isEnvironmentDev()) {
  environment = "https://s3-gw.suki-dev.com";
} else if (isEnvironmentTest()) {
  environment = "https://s3-gw.suki-test.com";
} else if (isEnvironmentStage()) {
  environment = "https://s3-gw.suki-stage.com";
} else if (isEnvironmentProd()) {
  environment = "https://s3-gw.suki.ai";
}

const INGESTER_CLIENT = new IngesterServiceClient(environment, null, null);
const AUTHER_CLIENT = new AutherClient(environment, null, null);

if (!isEnvironmentProd() && !isEnvironmentStage()) {
  const enableGRPCDevTools = window.__GRPCWEB_DEVTOOLS__ || (() => {});

  enableGRPCDevTools([INGESTER_CLIENT, AUTHER_CLIENT]);
}

const saveDataToCache = ({ organizationId, userId, name, email }) => {
  if (!window.localStorage[LO_STO.ORG_ID]) {
    window.localStorage.setItem(LO_STO.ORG_ID, organizationId);
  }

  if (!window.localStorage[LO_STO.USER_ID]) {
    window.localStorage.setItem(LO_STO.USER_ID, userId);
  }

  if (!window.localStorage[LO_STO.CURRENT_NAME]) {
    window.localStorage.setItem(LO_STO.CURRENT_NAME, name);
  }

  if (!window.localStorage[LO_STO.USER_EMAIL]) {
    window.localStorage.setItem(LO_STO.USER_EMAIL, email);
  }
};

const checkIsSukiUserAdmin = async ({ userId, organizationId }) => {
  const isStoredInLC = window.localStorage[LO_STO.IS_SUKI_USER_ADMIN];
  if (isStoredInLC === undefined) {
    const isSukiUserAdminVal = isSukiUserAdmin({ userId, organizationId });
    window.localStorage.setItem(LO_STO.IS_SUKI_USER_ADMIN, isSukiUserAdminVal);
  }
};

const getMetaData = () => {
  const oktaTokenStorage = window.localStorage["okta-token-storage"];
  const tokensParsed = oktaTokenStorage && JSON.parse(oktaTokenStorage);
  const oktaUser = window.localStorage.getItem(LO_STO.OKTA_USER);
  const jwt = tokensParsed?.idToken?.idToken;
  if (!jwt || _isNil(oktaUser)) return {};

  const oktaUserData = JSON.parse(oktaUser);
  //TODO: In case if there is no organization_ID we set default value. Probably that is right solution.
  const orgId = oktaUserData?.organizationID ?? ORGS.SUKI;
  const userId = oktaUserData?.userID;
  const name = oktaUserData?.name;
  const email = oktaUserData?.email;

  if (userId && orgId) {
    saveDataToCache({ organizationId: orgId, userId, name, email });
  }

  return {
    orgId,
    userId,
    email
  };
};

const getRequestMetadata = () => {
  try {
    const oktaTokenStorage = window.localStorage["okta-token-storage"];

    const jwtToken = window.localStorage.getItem(LO_STO.JWT_TOKEN) || JSON.parse(oktaTokenStorage)?.idToken?.idToken;
    const decodedJwt = jwtDecode(jwtToken);
    const tokenExpiry = decodedJwt?.exp;

    const tokenExpiresIn = moment.unix(tokenExpiry).diff(moment(), "minutes");

    if (!jwtToken || tokenExpiresIn <= 0) throw Error("User session is expired!");

    // new: suki_jwt
    return {
      suki_organization_id: getMetaData()?.orgId,
      suki_user_id: getMetaData()?.userId,
      s3_jwt: jwtToken,
      suki_jwt: jwtToken
    };
  } catch (e) {
    console.log(e);
    logoutUser();
    return {};
  }
};

export {
  AUTHER_CLIENT,
  checkIsSukiUserAdmin,
  getMetaData,
  getRequestMetadata,
  getCheckId,
  INGESTER_CLIENT,
  saveDataToCache
};
